"use client";

import useCheckRestrictedPage from "@/hooks/data/useCheckRestrictedPage";
import dynamic from "next/dynamic";
import React, { PropsWithChildren, useEffect, useState } from "react";

const UiMessageRestricted = dynamic(() => import("@/components/Ui/Message/Restricted").then(module => module.default));
export default function ContextRestricted({ children }: PropsWithChildren) {
  const restrictedSubject = useCheckRestrictedPage();
  const [isRestricted, setIsRestricted] = useState(false);

  useEffect(() => {
    setIsRestricted(!!restrictedSubject);
  }, [restrictedSubject]);

  return !isRestricted ? children : <UiMessageRestricted description="To access this page, you need to connect with your wallet." />;
}
